import React from 'react'
import Svg, { Path, Rect, SvgProps } from 'react-native-svg'

import { tID } from '../../utils/utils'

/**
 * Red octagon with a cross, used to signal a hard "no" (e.g. not eligible).
 *
 * Fixed-colour artwork: it takes no fill override.
 */
export const StopSignIcon = ({ size = 64, ...rest }: StopSignIconProps & SvgProps) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none' testID={tID('StopSignIcon')} {...rest}>
      <Path d='M19.574 62L2 44.426V19.573L19.574 2H44.428L62 19.573V44.426L44.428 62H19.574Z' fill='#EAAFAF' />
      <Rect x='43.4551' y='19.375' width='2' height='34' rx='1' transform='rotate(45 43.4551 19.375)' fill='#B63131' />
      <Rect x='44.7891' y='43.375' width='2' height='34' rx='1' transform='rotate(135 44.7891 43.375)' fill='#B63131' />
    </Svg>
  )
}

export type StopSignIconProps = {
  size?: number
}
